import { DOCUMENT } from '@angular/common';
import { Directive, HostListener, inject } from '@angular/core';

@Directive({
  selector: '[emperorPreventSubmissionOnAutocompleteEnter]',
})
export class PreventSubmissionWhenAutocompleteOpenDirective {
  readonly document = inject(DOCUMENT);
  readonly window = this.document.defaultView;

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      return this.preventDefaultWhenOptionsOpen();
    }
  }

  // An accessibility bug in the Google Maps autocomplete allows form submission
  // when the user selects an option by pressing the Enter key
  // This may be fixed in a future version
  preventDefaultWhenOptionsOpen(): undefined | false {
    const gPlaceChoices = this.document.querySelector('.pac-container');
    if (gPlaceChoices === null) {
      return; // allow submission
    }

    const choicesDisplay = this.window?.getComputedStyle(gPlaceChoices).display;
    if (choicesDisplay !== 'none') {
      return false; // preventDefault
    }
  }
}
